import { LatLng, VectorGridOptions, VectorTileLayerMouseEventHandler } from 'leaflet'
import { useCallback, useEffect, useState } from 'react'

type LayerPopupProps = {
  position: LatLng
  id: string
} | null

export function useLayerPopupHandler(
  active: boolean,
  getFeatureId: VectorGridOptions['getFeatureId'] = ({ properties }) => properties.id
): [LayerPopupProps, VectorTileLayerMouseEventHandler] {
  const [popupProps, setPopupProps] = useState<LayerPopupProps>(null)
  const handleClick = useCallback<VectorTileLayerMouseEventHandler>(
    ({ propagatedFrom, latlng }) =>
      setPopupProps({ id: getFeatureId(propagatedFrom), position: latlng }),
    [getFeatureId]
  )

  useEffect(() => {
    if (!active) {
      setPopupProps(null)
    }
  }, [active])

  return [popupProps, handleClick]
}
